import styled from "styled-components";
import { Flex } from "rebass";

export const Divider = styled(Flex)`
  &:before,
  &:after {
    content: ' ';
    flex: 1;
    height: 1px;
    background-color: #e6e6e6;
  }
`;

Divider.defaultProps = {
  alignItems: ["center"],
};
